
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(0(|06|79|9)|183|256|378|544|577|609|64|827|898)|2(7(36|6|7)|(14|25|34)0|[69]89|172|644|848|88|997)|5((0|15|93)5|211|279|366|638|694|900)|6(18[19]|69[45]|(25|27|53)6|009|317|338|430|463)|1(4(56|63|68)|5(12|33|78)|256|39|651|683|754|841|938)|8(3(05|32|76)|9(48|6|70)|(11|6|66)2|069|127|470|528|593|724)|7(9(66|92|97)|(14|42|6)7|016|076|410|659|770)|3(69[48]|(|8)08|244|395|457|787)|9(7(2|52|57)|(49|60|92)4|0|126|173|272|51|665|830|879))$/.test(chunkId);
},
rootOutputDir: "",

    };
}
